import { TradingSpinner, TradingTheme, useTradingTheme } from '@trading-ui/core';

import type { StylesObject } from '../../interfaces/global-interfaces';

const getStyles = (palette: TradingTheme['palette']): StylesObject => ({
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'grid',
    placeItems: 'center',
    zIndex: 50,
    top: 0,
    left: 0,
    backgroundColor: `rgba(25, 24, 26,${palette.mode === 'dark' ? 0.2 : 0.03})`,
  },
});

export default function TableLoader() {
  const { palette } = useTradingTheme();
  const styles = getStyles(palette);
  return (
    <div style={styles.container}>
      <TradingSpinner />
    </div>
  );
}
